export default __webpack_public_path__ + "static/media/default.a3cd25f95c0230385cb6ce30b55e38ea.png";